import Link from '@tiptap/extension-link'
import {
  TASK_DESCRIPTION_FILE_BLOB_URL_ATTR,
  TASK_DESCRIPTION_FILE_ID_ATTR,
} from '../../lib/taskTrackerDescription.utils'

export const TaskTrackerRichTextLink = Link.extend({
  addAttributes() {
    return {
      ...this.parent?.(),
      fileId: {
        default: null,
        parseHTML: (element) => element.getAttribute(TASK_DESCRIPTION_FILE_ID_ATTR),
        renderHTML: (attributes) => {
          const fileId = attributes.fileId
          if (fileId == null || fileId === '') return {}

          return {
            [TASK_DESCRIPTION_FILE_ID_ATTR]: String(fileId),
          }
        },
      },
      fileName: {
        default: null,
        parseHTML: (element) => element.getAttribute('data-file-name'),
        renderHTML: (attributes) => {
          const fileName = attributes.fileName
          if (!fileName) return {}

          return {
            'data-file-name': String(fileName),
          }
        },
      },
      blobUrl: {
        default: null,
        parseHTML: (element) =>
          element.getAttribute(TASK_DESCRIPTION_FILE_BLOB_URL_ATTR),
        renderHTML: (attributes) => {
          const blobUrl = attributes.blobUrl
          if (!blobUrl) return {}

          return {
            [TASK_DESCRIPTION_FILE_BLOB_URL_ATTR]: String(blobUrl),
          }
        },
      },
    }
  },
})
